export var NavMode;
(function (NavMode) {
    NavMode[NavMode["pan"] = 0] = "pan";
    NavMode[NavMode["crop"] = 1] = "crop";
    NavMode[NavMode["zoom"] = 2] = "zoom";
})(NavMode || (NavMode = {}));
export var Align;
(function (Align) {
    Align[Align["left"] = 0] = "left";
    Align[Align["right"] = 1] = "right";
    Align[Align["bottom"] = 2] = "bottom";
    Align[Align["top"] = 3] = "top";
    Align[Align["center"] = 4] = "center";
})(Align || (Align = {}));
export function isTouchEvent(e) {
    return e.type.toLowerCase().indexOf('touch') === 0;
}
export function zeroPad(num) {
    return num < 10 ? `0${num}` : num.toString();
}
export function contains(box, point) {
    return box.x <= point.x && point.x <= box.x + box.w && box.y < point.y && point.y < box.y + box.h;
}
